﻿import {$, $$, get, postDataText, initForm, isVisibleInViewport} from "@/Utils"
import { initFavorites } from "@/ProductModule";


function initScroll() {
  const accordion = $("#comparison-container .parameter-name") as HTMLElement;
  if (accordion) {
      // Synchronize horizontal scroll between header and table
      get("comparison-visual-header").addEventListener('scroll', headerScrollHandler, { passive: true });
      get("comparison-container").addEventListener('scroll', tableScrollHandler, { passive: true });
      
    window.addEventListener("scroll", () => {
      setStickyVisibility(accordion);
    });
  }
}

function setStickyVisibility(accordion: HTMLElement) {
    const comparisonSticky = get("comparison-visual-header") as HTMLElement;
    if (!accordion || !comparisonSticky) {
        return;
    }

    const comparisonPosition = accordion.getBoundingClientRect().top;
    if (comparisonPosition < 0) {
        comparisonSticky.classList.add("active");
    } else {
        comparisonSticky.classList.remove("active");
    }
}
// Create scroll handlers
function headerScrollHandler() {
    const header = get("comparison-visual-header") as HTMLElement
    const table = get("comparison-container") as HTMLElement
    if (header.dataset.syncing !== 'true') {
        table.dataset.syncing = 'true'
        table.scrollLeft = header.scrollLeft
        requestAnimationFrame(() => {
            table.dataset.syncing = 'false'
        })
    }
}

function tableScrollHandler(){
    const header = get("comparison-visual-header") as HTMLElement
    const table = get("comparison-container") as HTMLElement
    if (table.dataset.syncing !== 'true') {
        header.dataset.syncing = 'true'
        header.scrollLeft = table.scrollLeft
        requestAnimationFrame(() => {
            header.dataset.syncing = 'false'
        });
    }
}


function showDifferences(show: boolean) {
  get("comparison-container").classList.toggle("show-differences", show);
}

function initDifferences() {
  $$(".difference").forEach(x => {
    (x as Element).addEventListener("change", function () {
      const isChecked = this.checked;
      $$(".difference").forEach(y => {
        (y as HTMLInputElement).checked = isChecked;
      });
      showDifferences(isChecked);
    });
  });
}

function initRemoveClick() {
  $$("[data-comparison-remove-id]").forEach(x => {
    (x as Element).addEventListener("click", function () {
      const removeId = x.getAttribute("data-comparison-remove-id");
      const productIds = GetProductIds();
      const data = { removeId: parseInt(removeId), productIds: productIds };
      const callback = function (resp: string) {
        get("comparison-container").innerHTML = resp;
        const accordion = $(".comparison .accordion") as HTMLElement;
        setStickyVisibility(accordion);
        if (productIds) {
          RemoveProductIdFromUrl(productIds, removeId);
          $$("[data-lang]").forEach(x => {
            const url = x.getAttribute("href");
            x.setAttribute("href", RemoveProductIdFromUrl(productIds, removeId, url));
          });
        }
        initComparison();
        for(const x of Array.from($$("[data-comparison-remove-id]"))) {
            if(isVisibleInViewport(x)){
                x.focus()
                break
            }
        }
      }
      postDataText(window.config.removeFromComparisonUrl, data, callback);
    });
  });

}

function RemoveProductIdFromUrl(productIds: string, removeId: string, url?: string) {
    const separator = '-';
    let idList = productIds.split(separator);
    idList.splice(idList.indexOf(removeId), 1);
    var newIds = idList.join(separator);
    if (url) {
        return url.replace(productIds, newIds);
    }
    else {
        history.replaceState(null, null, location.href.replace(productIds, newIds));
    }
}

function GetProductIds() {
    const urlPieces = window.location.href.split('/');
    return urlPieces[urlPieces.length - 1];
}

function sendComparisonCallback(resp: Response) {
    return resp.text().then(x => { get("sendComparisonForm").innerHTML = x; });
}

function initComparison() {
    initScroll();
    initRemoveClick();
    initDifferences();
    initForm("sendComparisonForm", sendComparisonCallback);
    initFavorites();
}

window.addEventListener("load", () => {
    initComparison();
});